import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AdministrationActions } from './administration.actions';
import { AdministrationService } from '../../service/administration.service';
import { httpUserResponse } from './administration.model';
import { MessageService } from 'primeng/api';
import { tap } from 'rxjs/operators';
import { LegalEntitiesActions } from '../legal-entities/legal-entities.reducer';
import { UsersActions } from '../users/users.feature';
import { CptsActions } from '../cpt/cpt.actions';
import { RisksActions } from '../risk/risk.actions';
import { QualitativeActions } from '../qualitative/qualitative.reducer';
import { CampaignActions, DataMonitoringActions } from '../data-monitoring/data-monitoring.actions';
import { EvaluationActions } from '../evaluation/evaluation.actions';
import { GenericRiskMapActions, LegalEntityRiskMapActions, ProcessRiskMapActions, RiskMapRiskActions } from '../risk-map/risk-map.actions';
import { ThresholdActions } from '../threshold/threshold.actions';


@Injectable()
export class AdministrationEffects {
  constructor(
    private actions$: Actions,
    private messageService: MessageService
  ) { }

  handleAllErrors$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          LegalEntitiesActions.exportLegalEntitiesFailure,
          LegalEntitiesActions.loadLegalEntitiesFailure,
          LegalEntitiesActions.loadLegalEntitiesNamesFailure,
          // LegalEntitiesActions.syncronizeLegalEntitiesFailure,
          LegalEntitiesActions.loadLegalEntitiesCategoriesFailure,

          UsersActions.changeUserPermissionFailure,
          UsersActions.exportUsersFailure,
          UsersActions.loadUsersNamesFailure,
          UsersActions.loadUsersFailure,

          CptsActions.loadCptsFailure,
          CptsActions.exportCptsFailure,
          CptsActions.loadCptNamesFailure,
          // CptsActions.syncronizeCptsFailure,

          RisksActions.loadRisksFailure,
          RisksActions.exportRisksFailure,
          RisksActions.loadRiskNamesFailure,
          // RisksActions.syncronizeRisksFailure,

          QualitativeActions.createSectionFailure,
          QualitativeActions.createQuestionFailure,
          QualitativeActions.updateQuestionFailure,
          QualitativeActions.loadQualitativeFailure,
          QualitativeActions.loadQualitativeCategoriesFailure,

          CampaignActions.loadCampaignsFailure,
          CampaignActions.loadLastCampaignFailure,

          EvaluationActions.loadEvaluationsFailure,

          RiskMapRiskActions.loadRiskMapsFailure,

          GenericRiskMapActions.getRiskByCategoryFailure,
          GenericRiskMapActions.loadRiskMapsFullFailure,
          GenericRiskMapActions.updateAUFailure,

          ProcessRiskMapActions.loadRiskMapsFailure,

          LegalEntityRiskMapActions.loadRiskMapsFailure,

          DataMonitoringActions.loadDataMonitoringsFailure,
          DataMonitoringActions.validateDataMonitoringFailure,
          CampaignActions.validateCampaignFailure,

          ThresholdActions.updateThresholdIcsFailure,
          ThresholdActions.updateThresholdLikeFailure,
          ThresholdActions.updateThresholdImpactFailure

        ),
        tap((action) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `Error: ${action['error']?.message || 'Error undefined.'}`
          });
        })
      ),
    { dispatch: false }
  );

  // loadAdministrations$ = createEffect(() => {
  //   return this.actions$.pipe(

  //     ofType(AdministrationActions.loadAdministrations),
  //     mergeMap(() =>
  //       /** An EMPTY observable only emits completion. Replace with your own observable API request */
  //       EMPTY.pipe(
  //         map(data => AdministrationActions.loadAdministrationsSuccess({ data })),
  //         catchError(error => of(AdministrationActions.loadAdministrationsFailure({ error }))))
  //     )
  //   );
  // });

  // getUsers$ = createEffect((
  //   administrationService: AdministrationService = inject(AdministrationService),
  // ) => {
  //   return this.actions$.pipe(
  //     ofType(AdministrationActions.getUsers),
  //     mergeMap(({ filter }) =>
  //       administrationService.getUsers(filter).pipe(
  //         map((data: httpUserResponse) => AdministrationActions.getUsersSuccess({ user: data })),
  //         catchError(error => of(AdministrationActions.getUsersFailure())))
  //     )
  //   );
  // });


  // loadLegalEntityNames$ = createEffect((
  // ) => {
  //   return this.actions$.pipe(
  //     ofType(),
  //     mergeMap(() =>
  //       EMPTY.pipe(
  //         mergeMap(result => 
  //           LegalEntitiesActions.loadLegalEntitiesNames,
  //           LegalEntitiesActions.loadLegalEntitiesCategories,
  //         )
  //       )
  //     )
  //   );
  // },{functional: true});





}
